import React, { useEffect } from 'react'
import ChatWindow from './ChatWindow'
import { ChatbotProvider } from './context/ChatbotProvider'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { appInsights } from '../../../_services/AppInsights'
import { EventType } from '../../../utility/types'
import 'katex/dist/katex.min.css'
import './styles.css?v=1.0.4' //update the version when making changes to this file
import { useChatService } from './services/chatService'
import { defaultBreadcrumbs } from '../../../@core/layouts/new-VerticalLayout'
import { useDispatch } from 'react-redux'
import { setBreadCrumbMapper } from '../../../_redux/actions/breadCrumbMapperAction'

const Chatbot: React.FC = () => {
  //@ts-ignore
  const trackAliIconClick = useTrackEvent(appInsights, EventType.AliIconClicked)

  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const breadcrumbsMapper = [
    {
      ...defaultBreadcrumbs,
      onClick: () => navigate('/')
    },
    ...(location.pathname?.includes('chat')
      ? [
          {
            label: 'Ali'
          }
        ]
      : [])
  ]

  useEffect(() => {
    if (location.pathname?.includes('chat')) dispatch(setBreadCrumbMapper(breadcrumbsMapper))
  }, [location.pathname])

  useEffect(() => {
    if (location.state?.isNavClicked) {
      trackAliIconClick({ location: 'navbar' })
    }
  }, [])

  return (
    <div data-testid="chatbot-provider" className="h-100">
      <ChatbotProvider>
        <ChatWindow />
      </ChatbotProvider>
    </div>
  )
}
export default Chatbot
